var map = {
	"./common/background-mask.png": "dc68",
	"./common/header-logo.png": "b465",
	"./common/popup-close.png": "ed16",
	"./common/popup-scan.png": "4dca",
	"./common/promo-richart.png": "329d",
	"./desktop/button-arrow.png": "7590",
	"./desktop/button.png": "d0d5",
	"./desktop/image.png": "c502",
	"./game/logo.png": "85e5",
	"./game/part-1/button-arrow.png": "b8e5",
	"./game/part-1/icon-camera.png": "bba9",
	"./game/part-1/icon-check.png": "12d1",
	"./game/part-2/icon-hint-finger.png": "0a2c",
	"./game/part-2/icon-hint.png": "01a2",
	"./game/part-5/cards.png": "050e",
	"./game/part-7/brand.png": "d979",
	"./game/part-7/richart.png": "7cad",
	"./home/button-arrow.png": "67ce",
	"./home/button.png": "8dc7",
	"./home/caption.png": "9245",
	"./result/icon-again.png": "5a53",
	"./result/icon-download.png": "b0a5",
	"./result/icon-loading.png": "2610",
	"./result/icon-share.png": "d3ec",
	"./result/information-hint.png": "da66",
	"./result/information-title-tvc-1.png": "5e6d",
	"./result/information-title-tvc-2.png": "0554",
	"./result/information-title.png": "0562",
	"./result/information-video-cover.jpg": "3ab8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";